var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 512,
    viewBox: "0 0 520 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1978_34813)",
    filter: "url(#filter0_d_1978_34813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.208 19.6704C284.395 18.1811 282.279 17.106 280.007 16.5201C277.735 15.9342 275.363 15.8517 273.056 16.2784L17.056 64.2784C13.3856 64.9566 10.0692 66.9001 7.6837 69.7709C5.29823 72.6416 3.99473 76.2579 4.00002 79.9904V431.99C4.00002 439.67 9.47202 446.294 17.056 447.702L273.056 495.702C274.026 495.893 275.012 495.99 276 495.99C279.68 495.99 283.328 494.71 286.208 492.31C288.02 490.809 289.478 488.926 290.479 486.797C291.48 484.667 292 482.343 292 479.99V31.9904C292 27.2224 289.888 22.7104 286.208 19.6704ZM260 460.694L36 418.71V93.2704L260 51.2864V460.694Z",
    fill: "#475B78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 79.9902H276C267.168 79.9902 260 87.1582 260 95.9902C260 104.822 267.168 111.99 276 111.99H484V399.99H276C267.168 399.99 260 407.158 260 415.99C260 424.822 267.168 431.99 276 431.99H500C508.832 431.99 516 424.822 516 415.99V95.9902C516 87.1582 508.832 79.9902 500 79.9902Z",
    fill: "#475B78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 143.99H276C267.168 143.99 260 151.158 260 159.99C260 168.822 267.168 175.99 276 175.99H340C348.832 175.99 356 168.822 356 159.99C356 151.158 348.832 143.99 340 143.99ZM340 207.99H276C267.168 207.99 260 215.158 260 223.99C260 232.822 267.168 239.99 276 239.99H340C348.832 239.99 356 232.822 356 223.99C356 215.158 348.832 207.99 340 207.99ZM340 271.99H276C267.168 271.99 260 279.158 260 287.99C260 296.822 267.168 303.99 276 303.99H340C348.832 303.99 356 296.822 356 287.99C356 279.158 348.832 271.99 340 271.99ZM340 335.99H276C267.168 335.99 260 343.158 260 351.99C260 360.822 267.168 367.99 276 367.99H340C348.832 367.99 356 360.822 356 351.99C356 343.158 348.832 335.99 340 335.99ZM436 143.99H404C395.168 143.99 388 151.158 388 159.99C388 168.822 395.168 175.99 404 175.99H436C444.832 175.99 452 168.822 452 159.99C452 151.158 444.832 143.99 436 143.99ZM436 207.99H404C395.168 207.99 388 215.158 388 223.99C388 232.822 395.168 239.99 404 239.99H436C444.832 239.99 452 232.822 452 223.99C452 215.158 444.832 207.99 436 207.99ZM436 271.99H404C395.168 271.99 388 279.158 388 287.99C388 296.822 395.168 303.99 404 303.99H436C444.832 303.99 452 296.822 452 287.99C452 279.158 444.832 271.99 436 271.99ZM436 335.99H404C395.168 335.99 388 343.158 388 351.99C388 360.822 395.168 367.99 404 367.99H436C444.832 367.99 452 360.822 452 351.99C452 343.158 444.832 335.99 436 335.99ZM224.064 309.462L112.064 181.462C106.176 174.774 96.0964 174.134 89.4724 179.958C82.8164 185.782 82.1444 195.894 87.9684 202.518L199.968 330.518C201.466 332.237 203.315 333.615 205.391 334.559C207.466 335.503 209.72 335.991 212 335.99C215.744 335.99 219.488 334.678 222.56 332.022C229.216 326.198 229.888 316.118 224.064 309.462Z",
    fill: "#475B78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.824 163.382C214.848 157.91 204.8 159.222 199.36 166.166L87.3595 310.166C81.9515 317.142 83.1995 327.222 90.1755 332.63C92.9862 334.81 96.4426 335.992 99.9995 335.99C104.736 335.99 109.472 333.878 112.608 329.846L224.608 185.846C230.048 178.838 228.8 168.79 221.824 163.382Z",
    fill: "#475B78"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1978_34813",
    x: 0,
    y: 0,
    width: 520,
    height: 520,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1978_34813"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1978_34813",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1978_34813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportExcel);
export default __webpack_public_path__ + "static/media/export-excel.0097bcf9a0f260231ef8bee4724c593e.svg";
export { ForwardRef as ReactComponent };